/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output, ViewChild, signal,
} from '@angular/core';
import { CommunityStatusFormComponent, StatusDraft } from '../../common/community/feed/status-form/community-status-form.component';

// "Write your status update" card at the top of the community feed.
@Component({
  selector: 'ut-community-status-composer',
  templateUrl: './community-status-composer.component.html',
  styleUrls: ['./community-status-composer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityStatusComposerComponent implements OnInit {
  @Output() posted = new EventEmitter<any>();

  @ViewChild(CommunityStatusFormComponent) form: CommunityStatusFormComponent;

  posting = signal(false);
  // The composer posts as the current user, so the limit is the current user's.
  authorUserType = signal<string | null>(null);

  constructor(
    @Inject('StatusService') private StatusService: any,
    @Inject('AlertService') private AlertService: any,
    @Inject('ServerMessages') private ServerMessages: any,
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    this.UserService.me().then((res: any) => this.authorUserType.set(res?.data?.user_type ?? null));
  }

  post(draft: StatusDraft): void {
    this.posting.set(true);
    this.StatusService.create(draft.content, draft.attached_url).then((response) => {
      this.posted.emit(response.data);
      this.form.reset();
      this.AlertService.add('Status successfully posted');
    }, (response) => {
      this.AlertService.addDanger(this.ServerMessages.prettyMessage(response));
    }).finally(() => this.posting.set(false));
  }
}
